module.exports = __webpack_public_path__ + "static/media/omnibees.d6d2b810.png";